import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchSiteSettings = createAsyncThunk(
  'settings/fetchSettings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=settings-get');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const saveSiteSettings = createAsyncThunk(
  'settings/saveSettings',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post('/?action=settings-save', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const changePassword = createAsyncThunk(
  'settings/changePassword',
  async ({ password, password_confirm }, { rejectWithValue }) => {
    try {
      const response = await api.post('/?action=change-password', { password, password_confirm });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    siteSettings: null,
    loading: false,
    error: null,
    message: '',
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSiteSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSiteSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.siteSettings = action.payload;
      })
      .addCase(fetchSiteSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveSiteSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveSiteSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.siteSettings = action.payload;
        state.message = 'Configuración guardada';
      })
      .addCase(saveSiteSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.loading = false;
        state.message = 'Contraseña actualizada';
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearMessage } = settingsSlice.actions;
export default settingsSlice.reducer;
